import { Col, Row } from "antd";
import { Footer } from "antd/es/layout/layout";
import footerLogo from '../Assets/slts-logos.gif';

const CustomFooter = () => {
    return (
        <Footer style={{height:"auto"}}>
            {/* <Row> */}
            <div align="center">
                <img src={footerLogo} alt="Logo" className="footer-image" />
            </div>
            {/* </Row> */}
        </Footer>
    )
};
export default CustomFooter;